import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';

// 新建页/编辑页

// 区县

/**
 * 区县端
 * 新建页
 * 新建通知
 * @param {object} params
 */
export async function add(params) {
  return request(`${url.safeClock}/bell/create`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

/**
 * 学校端、区县端
 * 列表页
 * 待发布 立即发布
 * 接口提供者：蒋东明
 * @param {Integer} id
 */
export async function publish(payload) {
  return request(`${url.safeClock}/bell/publish?${stringify(payload)}`);
}

/**
 * 新建平安钟
 * 封面地址列表
 * 提供者： 陈新
 */
export function getMold(params) {
  return request(`${url.safeClock}/bell/get/mold?${stringify(params)}`);
}

/**
 * 新建平安钟
 * 获取发送应用列表
 * 提供者： 蒋东明
 */
export function getAppData(params) {
  return request(`${url.safeClock}/peacebell/external/list/from/app?${stringify(params)}`);
}

export function fetchReceiptTempList(params) {
  return request(`${url.safeClock}/v1/1122/receipt/template/list?${stringify(params)}`);
}

/**
 * 新建通知
 * 保存草稿
 * 提供者： 蒋东明
 * @params id: 消息的id
 */
export function saveDraft(params) {
  return request(`${url.safeClock}/bell/draft`, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

